const CACHE_ENTRY_TTL_MS = 3 * 60 * 1000;

type Cache<TResponse> = {
    [key: string]: Promise<TResponse>;
};

type RequestCache<TResponse> = {
    getRequest: (args: GetRequestArgs<TResponse>) => Promise<TResponse>;
    evictCacheByKey: (key: string) => void;
};

type GetRequestArgs<TResponse> = {
    requestFn: () => Promise<TResponse>;
    key: string;
    ttlMs?: number;
};

export const cacheRequests = <TResponse>(): RequestCache<TResponse> => {
    const cache: Cache<TResponse> = {};
    const timeouts: Record<string, number> = {};

    const getRequest = ({
        requestFn,
        key,
        ttlMs = CACHE_ENTRY_TTL_MS
    }: GetRequestArgs<TResponse>): Promise<TResponse> => {
        if (!cache[key]) {
            const timeoutId = window.setTimeout(() => {
                delete cache[key];
                delete timeouts[key];
            }, ttlMs);

            cache[key] = requestFn();
            timeouts[key] = timeoutId;
        }

        return cache[key];
    };

    const evictCacheByKey = (key: string) => {
        window.clearTimeout(timeouts[key]);
        delete cache[key];
        delete timeouts[key];
    };

    return { getRequest, evictCacheByKey };
};
